import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon } from '@heroicons/react/24/outline';

function Checkbox({
  checked,
  onChange,
  id,
  disabled = false,
  className = '',
  label,
  description,
  'aria-label': ariaLabel,
}) {
  const control = (
    <button
      id={id}
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={ariaLabel || (typeof label === 'string' ? label : undefined)}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`ios-checkbox ${checked ? 'ios-checkbox-checked' : ''} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`.trim()}
    >
      <AnimatePresence initial={false}>
        {checked ? (
          <motion.span
            key="check"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 520, damping: 28 }}
            className="ios-checkbox-icon"
          >
            <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} />
          </motion.span>
        ) : null}
      </AnimatePresence>
    </button>
  );

  if (!label && !description) return control;

  return (
    <label
      htmlFor={id}
      className={`ios-checkbox-row ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`}
    >
      {control}
      <span className="min-w-0 flex-1">
        {label ? <span className="ios-checkbox-label">{label}</span> : null}
        {description ? <span className="ios-checkbox-description">{description}</span> : null}
      </span>
    </label>
  );
}

export default Checkbox;
